import SchoolImage from '../../assets/images/schools.png';
import { useUserName } from '../../contexts/userName';
import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useLayoutEffect } from 'react';
import './style.scss';
import HatSchool from '../../assets/icons/hatSchool.svg';
import usersIcon from '../../assets/images/users.svg';
import BeneficiaryImage from '../../assets/images/admin-opt-4.png';
import WelcomeUser from '../../components/welcomeUser';
import { useRightSidePane } from '../../contexts/rightSidePane/rightSidePane';

function ProfileView() {
  // STATES //
  const { userName } = useUserName();
  const navigate = useNavigate();

  const { show } = useRightSidePane();

  useLayoutEffect(() => {
    const root = document.querySelector(':root');
    const cardWidth = document.querySelector('.item').clientWidth;
    const welcomeWidthDk = cardWidth * 2 + 32;
    root.style.setProperty('--welcome-user-width-dk', `${welcomeWidthDk}px`);
    root.style.setProperty('--welcome-user-width-mb', `${cardWidth}px`);
  });

  useEffect(() => {
    if (!userName) {
      navigate('/login');
    }
  }, [navigate, userName]);

  return (
    <>
      <section className='menu'>
        <div className='menu__wrapper wrapper'>
          <div className='wrapper__welcome'>
            <WelcomeUser></WelcomeUser>
          </div>
          <div className='wrapper__content content'>
            <Link to={'/escuelas'} className='content__item item'>
              <div className='item__def def'>
                <span className='def__text'>Escuelas</span>
                <img src={HatSchool} alt='opt-1-icon' className='def__icon' />
              </div>
              <img src={SchoolImage} alt='opt-1' className='item__img' />
            </Link>
            <div className='content__item item' onClick={() => show(true)}>
              <div className='item__def def'>
                <span className='def__text'>Beneficiarios</span>
                <img src={usersIcon} alt='opt-1-icon' className='def__icon' />
              </div>
              <img src={BeneficiaryImage} alt='opt-1' className='item__img' />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export { ProfileView };
